import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const PublicTrustPage = React.lazy(() => import("./PublicTrust"));
const TrustPersonPage = React.lazy(() => import("./TrustPersonPage"));

const publicTrustModuleConfig: ModuleConfig = {
  // 🏷️ MODULE IDENTITY — id MUST equal backend permissions.ts moduleId
  id: "public-trust",
  name: "Public Trust",
  description:
    "Track people in public life — local, state and federal politicians first — with a sourced activity log per person, each mirrored onto their own calendar.",
  version: "0.1.0",
  enabled: true,
  category: "business",
  order: 20,
  icon: "🏛️",
  // Module identity colour for the nav tile (not page chrome) — the same exemption bills takes.
  // eslint-disable-next-line no-restricted-syntax
  color: "#102c54",

  routes: [
    { path: "/public-trust", component: PublicTrustPage, permissionLevel: "view", useLayout: true },
    { path: "/public-trust/:id", component: TrustPersonPage, permissionLevel: "view", useLayout: true },
  ],

  navigation: [
    { label: "Public Trust", path: "/public-trust", icon: "🏛️", permissionLevel: "view" },
  ],

  // EMPTY — backend permissions.ts is the single source of truth.
  permissions: { view: [], create: [], edit: [], delete: [] },
};

export default publicTrustModuleConfig;
